import {on, trigger} from '@elements/dom-utils';
import {onFind} from '@elements/init-modules-in-scope';

export function init() {
    onFind('.js-reset-form', (element) => {
        on('click', () => {
            trigger('RESET', document.body);
        }, element);
    });
}

